export const SET_SEARCH_DELETED = 'SET_SEARCH_DELETED';
export const SET_SEARCH_TERM = 'SET_SEARCH_TERM';
export const INCREMENT_PAGE = 'INCREMENT_PAGE';
export const RESET_OFFSET = 'RESET_OFFSET';

interface SetSearchDeletedAction {
  type: typeof SET_SEARCH_DELETED;
  payload: boolean;
}

interface SetSearchTermAction {
  type: typeof SET_SEARCH_TERM;
  payload: string;
}

interface IncrementPageAction {
  type: typeof INCREMENT_PAGE;
}

interface ResetOffsetAction {
  type: typeof RESET_OFFSET;
}

export type actions =
  | SetSearchDeletedAction
  | SetSearchTermAction
  | IncrementPageAction
  | ResetOffsetAction;
